import styled from "@emotion/styled";
import { Box, List, ListItem, ListItemButton, ListItemText, Menu, MenuItem, MenuList, SxProps, Tooltip } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, themeSettings } from "../../../../configuration/themeSettings";
import GoToPage from "../../../GoToPage/GoToPage";


export const useClasses = {
    icon: {
        fontSize: 32,
    } as SxProps,
};


export const StyledList = styled(List, {
    label: "AppBasketMenu-menuMenuList",
})(({ theme }) => ({
    padding: 0,
    width: "400px",
    maxWidth: 355,
    height: "500px",
    maxHeight: 250,
    marginBottom: 62,
    display: "flex",
    flexDirection: "column",
    overflow: 'hidden',
    overflowY: 'auto',
    borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
    fontSize: 17,
}));


export const ContainerNameBasket = styled("div", {
  label: "AppBasketMenu-containerNameBasket",
})(({ theme }) => ({
  display: "flex",
  maxWidth: "100%",
  "> .MuiListItemIcon-root": {
    minHeight: 49,
    color: "#fff",
    position: "absolute",
    left: 8,
    top: 0,
    svg: {
      // width: 31,
      // height: 31,
      fontSize: 17,
    },
  },
}));

export const TextBasket = styled(ListItemText, {
    label: "AppBasketMenu-textBasket",
})(({ theme }) => ({
    paddingLeft: 0 + "px !important",
    alignContent: "center",
    marginTop: 0,
    marginBottom: 0,
    span: {
        fontSize: 11,
        lineHeight: 1.5,
        color: StyleguideSavioColors.text.black,
        span: {
            fontSize: 14,
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
    },
}));

export const MenuItemCustom = styled(MenuItem, {
    label: "AppBasketMenu-menuItemCustom",
})(({ theme }) => ({
    borderBottomColor: themeSettings.main.palette.grey[500],
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    paddingLeft: 32,
    paddingRight: 5,
}));


export const StyledListItem = styled(ListItem, {
    label: "AppBasketMenu-listItemCustom",
})(({ theme }) => ({
    borderBottomColor: StyleguideSavioColors.lightGrey,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    padding: 0,
    minHeight: 50,
    "&:last-child": {
        border: 0,
    },

    ".MuiListItemSecondaryAction-root": {
        display: 'flex',
        alignItems: 'center',

        "> div":{ display: 'flex',
            alignItems: 'center',
        "> div":{
            display: 'flex',
            alignItems: 'center',
            "svg":{
                fontSize: 23,
                color: StyleguideSavioColors.mainBlue,
            }
        }},
        "svg": {
            fontSize: 28,
            cursor: 'pointer',
        }
    },

    "&.selected": {
        backgroundColor: MiscSavio.hoverBackgroundTable,
        color: "#fff",
        "span": {
            color: "#fff",
        }
    },
    "&.selected .MuiListItemSecondaryAction-root": {
        "> div": {
            "svg":{
                color: "#fff",
            }
        }
    },

    "&:not(.selected):hover": {

        "span":{color: StyleguideSavioColors.blue,},
       

        "*": { textDecoration: 'underline',  },
        "&:before": {
            display: 'block',
            content: "''",
            width: 3,
            height: '100%',
            backgroundColor: StyleguideSavioColors.blue,
            left: 0,
            position: 'absolute',
            zIndex:1,

        },
        ' .MuiListItemButton-root':{
            backgroundColor:'#fff',
        }
    },
    "&>.MuiListItemButton-root": {
        paddingRight: 65,
    }
}));

export const StyledListItemButton = styled(ListItemButton, {
  label: "AppBasketMenu-listItemButtonCustom",
})(({ theme }) => ({
  margin: 0,
  paddingLeft: 32,
  paddingRight: 5,
  paddingBottom: 0,
  paddingTop: 0,
  minHeight: 49,
}));

export const MenuListCustom = styled(MenuList, { label: "search_bar-MenuListCustom" })
    (({ theme }) => ({
        
        "> li:first-of-type":{
            backgroundColor: MiscSavio.hoverBackgroundTable, 
            "svg":{
                position: 'absolute',
                fontSize: 17,
                left: 8,
            },
            "*":{
                color: '#fff',
            }
        },
        "> li":{
            paddingLeft: 32,

            "a":{
                textDecoration: 'none',
            },

            "&:not(:first-of-type)":{
                "&:hover":{
                    backgroundColor: 'inherit',
                    
                    "*":{textDecoration: 'underline',color: StyleguideSavioColors.blue,},
                    "&:before":{
                        display: 'block',
                        content: "''",
                        width: 3,
                        height: '100%',
                        backgroundColor: StyleguideSavioColors.blue ,
                        left:0,
                        position:'absolute',
                        
                        
                    }
                }
            }
        }
       
    }));

    export const LinkCustom = styled(GoToPage, { label: "search_bar-list-a" })
    (({ theme }) => ({
        display: 'block',
        width: '100%',
        color: StyleguideSavioColors.text.black + " !important",

        "&:hover": {
            //textDecoration: "underline !important",
            backgroundColor: "unset",
            //color: MiscSavio.hoverColor + " !important",
        }
    }))

    export const TransferBasketTooltipBox = styled(Box, {
        label: "AppBasketMenu-TransferBasketTooltipBox",
    })(({ theme: Theme }) => ({
        "& p": { fontSize: 11 },
        "& hr": { border: "1px solid" + themeSettings.main.palette.myGray.light },
    }));